import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private messageService: MessageService) {}

  success(summary: string, detail: string, options: any = {}): void {
    this.messageService.add({
      severity: 'success',
      summary: summary,
      detail: detail,
      life: options.nzDuration || 3000
    });
  }

  error(summary: string, detail: string, options: any = {}): void {
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: options.nzDuration || 3000
    });
  }

  info(summary: string, detail: string, options: any = {}): void {
    this.messageService.add({
      severity: 'info',
      summary: summary,
      detail: detail,
      life: options.nzDuration || 3000
    });
  }

  warning(summary: string, detail: string, options: any = {}): void {
    this.messageService.add({
      severity: 'warn',
      summary: summary,
      detail: detail,
      life: options.nzDuration || 3000
    });
  }
}